import { useUploadDebtorCSV, useUploadInvoiceCSV } from 'api/index';
import { useHistory } from 'react-router';
import { isDefined } from 'remeda';

import type { CsvData, MatchedColumns } from '../types.ts';
import { applyMatchedColumnsToData } from '../utils';

export function useSubmitCsvData() {
  const history = useHistory();

  const { mutate: uploadInvoiceCsv, isPending: isUploadInvoiceLoading } = useUploadInvoiceCSV();
  const { mutate: uploadDebtorCsv, isPending: isUploadDebtorLoading } = useUploadDebtorCSV();

  const submit = (
    isInvoiceMode: boolean,
    matchedColumns: MatchedColumns,
    csvData: CsvData,
    shouldForceBalanceUpdate?: boolean,
  ) => {
    if (!isDefined(csvData)) return;

    const processedData = applyMatchedColumnsToData(csvData, matchedColumns);

    const options = {
      onSuccess: () => history.push('/dashboard'),
    };

    if (isInvoiceMode) {
      uploadInvoiceCsv(
        {
          data: {
            force_balance_update: shouldForceBalanceUpdate,
            invoices: processedData,
          },
        },
        options,
      );
    } else {
      uploadDebtorCsv({ data: { debtors: processedData } }, options);
    }
  };

  return { submit, isSubmitloading: isUploadInvoiceLoading || isUploadDebtorLoading };
}
